<div class="bloc">
  <div class="bloc-header">
    <div class="bloc-title">Mode de connexion</div>
  </div>
  <div class="radio-grid">
    <label class="radio-item">
      <input type="radio" name="connectionMode" value="cabinet" [(ngModel)]="form.mode"
             (ngModelChange)="onModeChange()"/>
      <span class="radio-mark"></span>
      <span>Cabinet</span>
    </label>
    <label class="radio-item">
      <input type="radio" name="connectionMode" value="maisonMedicale" [(ngModel)]="form.mode"
             (ngModelChange)="onModeChange()"/>
      <span class="radio-mark"></span>
      <span>Maison médicale</span>
    </label>
    <label class="radio-item">
      <input type="radio" name="connectionMode" value="pmg" [(ngModel)]="form.mode" (ngModelChange)="onModeChange()"/>
      <span class="radio-mark"></span>
      <span>PMG</span>
    </label>
    <div class="sub-option" *ngIf="form.mode === 'pmg'">
      <label class="checkbox-item">
        <input type="checkbox" [(ngModel)]="form.is1733" (ngModelChange)="onFieldChange()"/>
        <span class="checkmark"></span>
        <span>1733</span>
      </label>
    </div>
  </div>
</div>
